import { Injectable } from '@angular/core';
import { StorageService } from '@nagel-services';
import { ApplicationDateAdapter, DATE_LOCALE } from '@nagel-utils';

const DATE_FORMATS = {
    ddmmyyyyhhmm: 'DD/MM/YYYY, HH:mm',
    MMMYYYY: 'MMM YYYY'
};

@Injectable()
export class CustomDateAdapter extends ApplicationDateAdapter {
    // Define custom date formats and their corresponding formatting methods
    override DATE_FORMATTING_OPTIONS = {
        [DATE_FORMATS.ddmmyyyyhhmm]: {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        },
        [DATE_FORMATS.MMMYYYY]:{
            year: 'numeric',
            month: 'short'
        }
    };

    constructor(private storageService: StorageService) {
        super();
    }

    override getDateLocale = (displayFormat: string): string => {
        const storedLocale = this.storageService.getItem('locale');
        let locale = storedLocale === 'de' ? DATE_LOCALE.DE : DATE_LOCALE.EN_UK;

        return displayFormat === DATE_FORMATS.ddmmyyyyhhmm
            ? DATE_LOCALE.EN_UK
            : locale;
    };
}